import {z} from "zod";

export enum RecaptchaVersion {
    V2 = "V2",
    V3 = "V3",
}

export enum RecaptchaAction {
    LOGIN = "login",
    SIGNUP = "signup",
    CONTACT = "contact",
    RESET_PASSWORD = "reset_password",
    CHECKOUT = "checkout",
    SEND_TOKEN = "send_token",
    VERIFY_TOKEN = "verify_token",
}

export const reCaptchaSchema = {
    captchaVersion: z.enum([RecaptchaVersion.V2, RecaptchaVersion.V3]),
    captcha: z.string().nullable().optional(),
};